app.directive('scrolledToBottom', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var raw = element[0];

            // Listen for the scroll event
            element.bind('scroll', function () {
                // Add a small 5px buffer to account for fractional pixel calculation differences in some browsers
                if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight - 5) {
                    scope.$apply(attrs.scrolledToBottom);
                }
            });

            // Edge case: If the content is too short to have a scrollbar, trigger immediately.
            // Using $timeout ensures the DOM has finished rendering the injected HTML first.
            $timeout(function () {
                if (raw.scrollHeight <= raw.offsetHeight) {
                    scope.$eval(attrs.scrolledToBottom);
                }
            }, 100);
        }
    };
}]);